<template>
  <div class="footer">
    <el-dialog v-model="isDetailShowed" :title="currentTitle" width="50%" :html="true" align-center
               class="footer-dialog">
      <div v-html="currentData"></div>
    </el-dialog>
    <div class="footer-title">
      <p class="title-head font-xbs"><span style="color: #fa7c0a;">解困式</span>报道中国案例库</p>
      <p>
        {{ aboutUs.websummary }}
        </p>
    </div>
    <div class="more">
      <div class="footer-about">
        <div class="about-title unselectable">关于</div>
        <div class="about-title-detail" v-for="(title, index) in aboutUs.titles" :key="index"
             @click="showDetail(index)">{{
            title
          }}
        </div>
      </div>
      <div class="footer-link">
        <div class="link-title unselectable">友情链接</div>

        <div v-for="partner in aboutUs.partners" :key="partner.id" class="partner">
          <template v-if="partner.qrcode_url">
            <div class="title">{{ partner.title }}</div>
            <div class="qrcode" v-if="partner.qrcode_url">
              <img :src="partner.qrcode_url" alt="">
            </div>
          </template>
          <template v-else>
            <div class="title" v-if="!partner.url">{{ partner.title }}</div>
            <a class="title" v-else :href="partner.url" target="_blank">{{ partner.title }}</a>
          </template>
        </div>
      </div>
    </div>
    <div class="footer-jiekun"></div>
  </div>
</template>

<script setup lang="ts">
import getAboutUs from '@/api/aboutUs'
import escape2html from '@/api/escape2html'
import {onMounted, reactive, ref} from 'vue';
import type {Partner} from "@/types/types";
import {getPartners} from "@/api/getPartners";
import {getConfig} from '@/api/getConfig';

const {fetchingFooter} = getAboutUs()
const {toHtml} = escape2html()
const currentData = ref('')
const currentTitle = ref('')
const isDetailShowed = ref(false)
const aboutUs = reactive({
  footer: [] as aboutUsDetail[],
  titles: [] as string[],

  partners: [] as Partner[],
  websummary: '' as string,
})

type aboutUsDetail = {
  content: string,
  id: number,
  sort: string,
  title: string,
}

onMounted(async () => {
  aboutUs.footer = await fetchingFooter()
  for (var i = 0; i < aboutUs.footer.length; i++) {
    aboutUs.titles.push(aboutUs.footer[i].title)
  }

  const {partners} = await getPartners()
  aboutUs.partners = partners

  const {config} = await getConfig('web_footer_summary')
  aboutUs.websummary = config

})

const showDetail = (index: number) => {
  currentData.value = toHtml(aboutUs.footer[index].content)
  currentTitle.value = aboutUs.footer[index].title
  isDetailShowed.value = true
}

</script>

<style scoped lang="scss">
.footer-dialog {
  .el-dialog__header {
    margin: 0;
    padding: 40px 40px 0 40px;
  }

  .el-dialog__body {
    padding: 20px 40px 40px 40px;
  }

  .el-dialog__title {
    font-size: 24px;
    color: #fa7c0a;
    font-weight: 500;
  }
}

.about-title-detail {
  cursor: pointer;
}

.about-title-detail:hover {
  color: #fa7c0a !important;
}

.footer {
  width: 100%;
  height: 365px;
  box-shadow: inset 0px 30px 20px -10px rgba(0, 0, 0, 0.1);
  padding-top: 10px;
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 100px;
}

.footer-title {
  width: 50%;
  height: 80%;
  padding: 0 80px;
  /* background-color: aqua; */
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
}

.footer-title > p {
  margin: 10px;
}

.title-head {
  font-size: 40px;
  font-weight: 525;
}

.footer-jiekun {
  background-image: url(/assets/imgs/jiekunFooter.jpg);
  width: 216px;
  height: 78px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: absolute;
  left: 0;
  bottom: 0;
}

.more {
  display: flex;
  align-items: start;
  justify-content: flex-start;
  margin-left: auto;
  margin-right: 120px;
}

.footer-about,
.footer-link {
  width: 150px;
  height: max-content;
  /* background-color: aqua; */
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;

  .partner {
    position: relative;

    &:hover {
      .qrcode {
        opacity: 1;
      }
    }

    .qrcode {
      position: absolute;
      width: 100px;
      opacity: 0;
      pointer-events: none;
      transition: opacity .3s;
      padding: 5px;
      background: #ffffff;
      box-shadow: 0 0 10px #cccccc;
      margin-top: 5px;
      z-index: 10;

      img {
        width: 100%;
        height: auto;
      }
    }
  }
}

.footer-about > div,
.footer-link > div {
  margin: 10px;
}

.footer-about > div:not(.about-title),
.footer-link > div:not(.link-title) {
  color: #a2a5a9;
}

.about-title,
.link-title {
  font-size: 25px;
  font-weight: 550;
}

a {
  text-decoration: none;
  outline: none;
  color: #a2a5a9;
}
</style>